var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative",
      background: "#fff"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", {
    staticClass: "banner"
  }, [_vm._v(" " + _vm._s(_vm.$t("产品图片")) + " "), _vm.styleObj.controlsLogoDisplay ? [_vm.styleObj.controlsComponentsMark != "mainDrawing1" && _vm.styleObj.controlsComponentsMark != "mainDrawing6" ? _c("div", {
    staticClass: "logoBox",
    class: _vm.styleObj.controlsComponentsMark == "mainDrawing3" || _vm.styleObj.controlsComponentsMark == "mainDrawing7" ? "logoBox3" : ""
  }, [_vm._v(" logo ")]) : _vm._e()] : _vm._e()], 2), _vm.styleObj.controlsComponentsMark == "mainDrawing4" ? _c("div", {
    staticClass: "insurance"
  }, [_c("div", {
    staticClass: "bg",
    style: "background:" + _vm.themeColor
  }), _c("div", {
    style: "color:" + _vm.themeColor
  }, [_vm._v(_vm._s(_vm.$t("本产品由xxx公司承保")))])]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "mainDrawing1" || _vm.styleObj.controlsComponentsMark == "mainDrawing2" || _vm.styleObj.controlsComponentsMark == "mainDrawing6" ? _c("div", [_c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "infoBox"
  }, [_c("div", {
    staticClass: "name",
    style: "font-size:" + _vm.styleObj.productNameFontSize + "px;color:" + _vm.styleObj.productNameColor
  }, [_vm._v(" " + _vm._s(_vm.$t("产品名称")) + " "), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("@/assets/template/mainDrawing/icon_" + _vm.themeColor + ".png")
    }
  })]), _vm.styleObj.controlsComponentsMark == "mainDrawing1" || _vm.styleObj.controlsComponentsMark == "mainDrawing6" ? _c("div", {
    staticClass: "des",
    style: "font-size:" + _vm.styleObj.otherFieldsFontSize + "px;color:" + _vm.styleObj.otherFieldsColor
  }, [_vm._v(" " + _vm._s(_vm.$t("本产品由xxx公司承保")) + " ")]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "mainDrawing2" ? _c("div", {
    staticClass: "characteristicList"
  }, _vm._l(3, function (item) {
    return _c("div", {
      key: item
    }, [_c("div", {
      staticClass: "bg",
      style: "background:" + _vm.styleObj.otherFieldsColor
    }), _c("div", {
      style: "font-size:" + _vm.styleObj.otherFieldsFontSize + "px;color:" + _vm.styleObj.otherFieldsColor
    }, [_vm._v(" " + _vm._s(_vm.$t("产品特点")) + " ")])]);
  }), 0) : _vm._e(), _vm.styleObj.controlsComponentsMark == "mainDrawing6" ? _c("div", {
    staticClass: "des",
    style: "font-size:" + _vm.styleObj.otherFieldsFontSize + "px;color:" + _vm.styleObj.otherFieldsColor
  }, [_vm._v(" " + _vm._s(_vm.$t("本产品由xxx公司")) + _vm._s(_vm.styleObj.thirdCompanySuffix) + " ")]) : _vm._e()]), _vm.styleObj.controlsLogoDisplay ? [_vm.styleObj.controlsComponentsMark == "mainDrawing1" || _vm.styleObj.controlsComponentsMark == "mainDrawing6" ? _c("div", {
    staticClass: "logo"
  }, [_vm._v(" logo ")]) : _vm._e()] : _vm._e()], 2)]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "mainDrawing3" || _vm.styleObj.controlsComponentsMark == "mainDrawing4" || _vm.styleObj.controlsComponentsMark == "mainDrawing5" || _vm.styleObj.controlsComponentsMark == "mainDrawing7" ? _c("div", [_c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "infoBox"
  }, [_c("div", {
    staticClass: "name",
    style: "font-size:" + _vm.styleObj.productNameFontSize + "px;color:" + _vm.styleObj.productNameColor
  }, [_vm._v(" " + _vm._s(_vm.$t("产品名称")) + " ")]), _vm.styleObj.controlsComponentsMark == "mainDrawing3" || _vm.styleObj.controlsComponentsMark == "mainDrawing7" ? _c("div", {
    staticClass: "des",
    style: "font-size:" + _vm.styleObj.otherFieldsFontSize + "px;color:" + _vm.styleObj.otherFieldsColor
  }, [_vm._v(" " + _vm._s(_vm.$t("本产品由xxx公司承保")) + " ")]) : _c("div", {
    staticClass: "des",
    style: "font-size:" + _vm.styleObj.otherFieldsFontSize + "px;color:" + _vm.styleObj.otherFieldsColor
  }, [_vm._v(" " + _vm._s(_vm.$t("备案号") + "：xxxxxxx") + " ")]), _vm.styleObj.controlsComponentsMark == "mainDrawing7" ? _c("div", {
    staticClass: "des",
    style: "font-size:" + _vm.styleObj.otherFieldsFontSize + "px;color:" + _vm.styleObj.otherFieldsColor
  }, [_vm._v(" " + _vm._s(_vm.$t("本产品由xxx公司")) + _vm._s(_vm.styleObj.thirdCompanySuffix) + " ")]) : _vm._e()]), _c("div", {
    staticClass: "logo icon"
  }, [_c("img", {
    staticClass: "img3",
    attrs: {
      src: require("@/assets/template/mainDrawing/icon_" + _vm.themeColor + ".png")
    }
  })])])]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "mainDrawing5" ? _c("div", {
    staticClass: "insurance"
  }, [_c("div", {
    staticClass: "bg",
    style: "background:" + _vm.themeColor
  }), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t("本产品由xxx公司承保")))])]) : _vm._e(), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };